module.exports = __webpack_public_path__ + "img/horizontal_2_1_9016.bc3de130.png";